module.exports = {"defaultFileName":"리스트","errorOccurred":"에러가 발생했습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/excel.json
// module id = gKYw
// module chunks = 2